var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d0e357d298f917d43d40eae8fb8e2c9661d4223f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["eskolare-next@eskolare"]={id:"d0e357d298f917d43d40eae8fb8e2c9661d4223f"};
      